var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M76.552-62.843l-42.277.306a4.448,4.448,0,0,1-4.463-4.382l-.328-40.45a4.437,4.437,0,0,1,4.375-4.459l42.277-.3a4.449,4.449,0,0,1,4.463,4.38l.328,40.45A4.438,4.438,0,0,1,76.552-62.843Z",
    transform: "translate(-29.484 112.13)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M-724,1074.258H21.086V-1156H-724Z",
    transform: "translate(724 1156)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M77.369-65.257,40.2-64.976A1.878,1.878,0,0,1,38.3-66.845l-.282-33.432a1.876,1.876,0,0,1,1.87-1.906l37.166-.281a1.881,1.881,0,0,1,1.908,1.872l.282,33.428A1.875,1.875,0,0,1,77.369-65.257Z",
    transform: "translate(-38.014 102.464)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M64.089-67.6,50.531-67.5l6.721-7.738Z",
    transform: "translate(-50.531 75.24)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M78.485-69.74,58.941-69.6,68.62-80.71Z",
    transform: "translate(-58.941 80.71)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Image_Square",
    "data-name": "Image Square",
    transform: "translate(-74 -289)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 155,
    height: 155,
    transform: "translate(74 289)",
    fill: "#dbe6f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1073",
    "data-name": "Group 1073",
    transform: "translate(107.476 460.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1062",
    "data-name": "Group 1062",
    transform: "translate(18.524 -118.012)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1061",
    "data-name": "Group 1061",
    transform: "translate(-470.982 -652.494)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M24.484-117.13H82.178v55.844H24.484Z",
    transform: "translate(443.373 766.499)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1064",
    "data-name": "Group 1064",
    transform: "translate(23.856 -111.97)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1063",
    "data-name": "Group 1063",
    transform: "translate(-476.314 -658.536)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M33.014-107.464H80.49v43.739H33.014Z",
    transform: "translate(440.175 762.875)",
    fill: "#eaedf9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1066",
    "data-name": "Group 1066",
    transform: "translate(31.68 -94.953)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1065",
    "data-name": "Group 1065",
    transform: "translate(-484.138 -675.553)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M45.531-80.24H65.34v13.989H45.531Z",
    transform: "translate(435.482 752.668)",
    fill: "#b0b7c4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1068",
    "data-name": "Group 1068",
    transform: "translate(36.936 -98.372)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1067",
    "data-name": "Group 1067",
    transform: "translate(-489.395 -672.134)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M53.941-85.71H79.735v17.358H53.941Z",
    transform: "translate(432.328 754.719)",
    fill: "#cdd6e1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImg);
export default __webpack_public_path__ + "static/media/NoImg.3209d6325c484ebbf30f61dadd44a223.svg";
export { ForwardRef as ReactComponent };